import constants from "constants/index";

export const states = [
  "AK",
  "AL",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DC",
  "DE",
  "FL",
  "GA",
  "GU",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MH",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "PR",
  "PW",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VI",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];

export const companyIdOptions = [
  { companyId: "APC", name: "ALLIED PACIFIC OF CALIFORNIA" },
  { companyId: "ADV", name: "ADVANTAGE HEALTH NETWORK" },
  { companyId: "APPAACO", name: "APPAACO" }, //TODO - no one knows what the name of this IPA is
  { companyId: "APCMG", name: "ACCESS PRIMARY CARE MEDICAL GROUP" },
  { companyId: "AVISTA", name: "ALLIED PHYSICIANS IPA (ARROYO VISTA)" },
  { companyId: "CVIPA", name: "EMANATE HEALTH IPA" },
  { companyId: "GOM", name: "GREATER ORANGE MEDICAL GROUP" },
  { companyId: "GSGP", name: "GREATER SAN GABRIEL VALLEY PHYSICIANS IPA" },
  { companyId: "AHC", name: "ACCOUNTABLE HEALTH CARE" },
  { companyId: "ALPHA", name: "ALPHA CARE MEDICAL GROUP" },
  { companyId: "BAIPA", name: "BEVERLY ALIANZA IPA" },
  { companyId: "CFC", name: "COMMUNITY FAMILY CARE" },
  { companyId: "LSMA", name: "LA SALLE MEDICAL ASSOCIATES" },
  { companyId: "JADE", name: "Jade Health" },
  { companyId: "AAMG", name: "All American Medical Group" },
  { companyId: "CVMG", name: "CENTRAL VALLEY MEDICAL GROUP" },
  { companyId: "AMTX", name: "Apollocare Partners of Texas" },
  { companyId: "ACPAZ", name: "ACPAZ" },
  { companyId: "BACP", name: "BACP" },
  { companyId: "AMNV", name: "Apollocare Partners of Nevada" },
  { companyId: "MDPTN", name: "MD Partners" },
];

export const APCGroup = [
  "APC",
  "ADV",
  "APPAACO",
  "APCMG",
  "AVISTA",
  "CVIPA",
  "GOM",
  "GSGP",
];
export const IPAData = constants.IS_PROD
  ? [
      { value: "AAMG", name: "AAMG" },
      { value: "ACPAZ", name: "ACPAZ" },
      { value: "AHC", name: "AHC" },
      { value: "AHISP", name: "AHISP" },
      { value: "ALPHA", name: "ALPHA" },
      { value: "AMNV", name: "AMNV" },
      { value: "AMTX", name: "AMTX" },
      { value: "APC", name: "APC/APCMG/EHIPA/Subs" },
      { value: "BACP", name: "BACP" },
      { value: "BAIPA", name: "BAIPA" },
      { value: "CCPP", name: "CCPP" },
      { value: "CFC", name: "CFC" },
      { value: "CVMG", name: "CVMG" },
      { value: "JADE", name: "JADE" },
      { value: "MDPTN", name: "MDPTN" },
    ]
  : [
      { value: "AAMG", name: "AAMG" },
      { value: "ACPAZ", name: "ACPAZ" },
      { value: "AHC", name: "AHC" },
      { value: "STAGING", name: "AHC_STAGING" },
      { value: "AHISP", name: "AHISP" },
      { value: "ALPHA", name: "ALPHA" },
      { value: "AMNV", name: "AMNV" },
      { value: "AMTX", name: "AMTX" },
      { value: "APC", name: "APC/APCMG/EHIPA/Subs" },
      { value: "BACP", name: "BACP" },
      { value: "BAIPA", name: "BAIPA" },
      { value: "CFC", name: "CFC" },
      { value: "CVMG", name: "CVMG" },
      { value: "JADE", name: "JADE" },
      { value: "DEMO", name: "DEMO" },
      { value: "CCPP", name: "CCPP" },
      { value: "MDPTN", name: "MDPTN" },
    ];

export const diagRefCode = ["DR", "MR", "RA", "RR", "UR"];

export const USER_GUIDE_PATH = "/Web/Forms/WebPortalUserGuide.pdf";
export const STAGING_ROOT = "https://provider-portal-test.nmm.cc";

export const EXPIRING_PROVIDER_ID_LIST = [
  "1629162243_HNTPK3034",
  "1366451908_PARAM1666",
  "1215949367",
  "SPC-A78806ACC",
  "SPC-A45139CVI",
  "SPC-G54062",
  "SPC-A102032ACC",
  "1760804157SGVP",
  "SPC-A54788ACC",
  "1881717635_LA_1300",
  "1730160174_GRDNA1141",
  "1962578120",
  "1295788933",
  "1053474783_PARAM1666",
  "1164673976_LA8635",
  "1205845583",
  "1205845583_VANNY1356",
  "1861449373_LB_790",
  "SPC-10484",
  "SPC-A83662",
  "SPC-A89372GOM",
  "SPC-42381CVI",
  "1184614216_LA_1407",
  "250238",
  "SPC-G69580ACC",
  "SPC-94132",
  "1538340195",
  "1851525695",
  "1942246111_LA_1414",
  "SPC-C39836GOM",
  "SPC-E4385",
  "1013084979_LB_2801",
  "1023210721_LYNWD3660",
  "SPC-A71033GOM",
  "SPC-A90085",
];

export const riversideProximityCities = [
  "COLTON",
  "LOMA LINDA",
  "FONTANA",
  "RIOLTO",
  "SAN BERNARDINO",
  "CORONA",
  "MORENO VALLEY",
  "PERRIS",
  "NORCO",
  "REDLANDS",
  "RIVERSIDE",
];

export const OBG_CPTCODES = [
  "59400",
  "59510",
  "59610",
  "59410",
  "59515",
  "59612",
  "59409",
  "59514",
];

export const MAMMOGRAM_EXCLUDED_CPTCODES = [
  "77067",
  "76641",
  "77066",
  "77065",
  "77049",
  "19081",
  "19083",
  "19085",
  "19281",
  "19285",
];

export const MAMMOGRAM_EXCLUDED_PROVIDER_KEY_LIST = [
  "0704D535-AB52-42CF-A600-02CFEDCAF07A",
  "64C1975F-55F7-4F00-B080-D8C77F2B90F8",
];

export const UPLOAD_REPORT_MEASURE_CODES = [
  "MHW3015",
  "MHW3030",
  "MHWCV",
  "MHBCS",
  "MHKED",
  "MHPPCTPC",
  "MHPPCPC",
  "MHCHL",
  "MHCCS",
  "MHEED",
  "MHHBD",
  "MHCOL",
  "MHCOAFSA",
  "MHCOAPA",
  "MHWCCBMI",
  "MHWCCNUT",
  "MHWCCPA",
  "MHOMW",
  "MHLSC",
  "MHAPE",
];

export const H5499_POS_CODES = ["21", "31", "51", "61"];

export const EHIPA_DEFAULT_EXPIRY_DAYS = 120;

export const HEALTH_NET_LOBS = [
  "HNEM",
  "HNES",
  "HNMC",
  "HNCC",
  "HNET",
  "HNEP",
  "HCON",
  "HNEMFR",
];

export const EXPRESS_RX_AUTOMATIC_EXTENSION_IPAS = ["ALPHA", "LSMA"];

export const EXPRESS_RX_PROVIDER_ID = "1184777286";

export const EDI_CLAIM_NON_REJECTED_STATUSES = [
  "ACCEPTED",
  "PENDING",
  "IN PROCESS",
];

export const EDI_REJECTED_STATUS = "REJECTED";

export const EDI_INPROCESS_STATUS = "IN PROCESS";

export const ALERT_TYPES = ["WARNING", "INFO", "ERROR"];

export const ALLOWED_VENDOR_FACILITIES_FOR_AUTH_MODIFICATION = [
  "912155421",
  "273205326",
];

export const BLOOD_PRESSURE_MEASURE_CODES = ["MHCBP", "MHBPD", "BPD"];

export const SCAN_COMPASS_CPT_CODES = [
  "99201",
  "99202",
  "99203",
  "99204",
  "99205",
];

export const SCAN_COMPASS_IPAS = ["APC", "AHC", "ALPHA"];

export const SCAN_SPEC_CODES = ["C", "D", "END", "GI", "GYN", "OPH", "POD"]; // Cardiology, Dermatology, Endocrinology, Gastroenterology, Gynecology, Ophthalmology, Podiatry

export const SCAN_OPTS = ["2024H5425115LA", "2024H5425115SB"];

export const SCAN_HPS = ["SCAPCAH", "SCAPCFY", "SCAHCAH", "SCAHCFY", "SCALPFY"];

export const ORGANIZATION_NAME = "Astrana Health";

export const DOCUMENTS_LANGUAGE = [
  "English",
  "Spanish",
  "Chinese",
  "Vietnamese",
  "Tagalog",
];

export const ALL_TEXT = "ALL";

export const MEMBER_ADDED_TEXT = "Member Added";
